<div class="font-sm font-italic text-center mt-1">
  <ng-content></ng-content>
</div>
